import { createSvgIcon } from "@mui/material";

const WarningDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.3333C0 9.55126 9.55126 0 21.3333 0H58.6667C70.4487 0 80 9.55126 80 21.3333V58.6667C80 70.4487 70.4487 80 58.6667 80H21.3333C9.55126 80 0 70.4487 0 58.6667V21.3333Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M39.4828 25.1825L20.9834 58.6008C19.6706 60.9878 21.3415 63.9716 24.0866 63.9716H61.0854C63.8305 63.9716 65.6207 60.9878 64.1885 58.6008L45.6891 25.1825C44.3762 22.6761 40.7957 22.6761 39.4828 25.1825Z"
      fill="#FFE0B2"
    />
    <path
      d="M34.5142 19.8904C36.5103 16.3972 41.6152 16.2764 43.5494 19.9052L54.0524 38.7628L54.0897 38.8336C54.4533 39.5719 54.1775 40.4737 53.4504 40.8787C52.7233 41.2837 51.8116 41.0431 51.3753 40.3453L51.3345 40.2767L40.8315 21.4191C40.825 21.4075 40.819 21.3957 40.8128 21.3839C40.1068 20.0361 38.0775 19.9257 37.2156 21.4338L30.4231 33.7086L27.7008 32.2021L34.5038 19.9091L34.5142 19.8904ZM30.4231 33.7086C30.0071 34.4602 29.0606 34.7321 28.3089 34.3162C27.5572 33.9002 27.2849 32.9537 27.7008 32.2021L30.4231 33.7086Z"
      fill="#FF9800"
    />
    <path
      d="M24.0024 39.0041C24.4191 38.2528 25.3657 37.9815 26.117 38.3982C26.8683 38.8149 27.1395 39.7615 26.7229 40.5128L18.8458 54.7155C18.0787 56.1179 19.0884 57.7765 20.5884 57.7767H57.5875C59.1854 57.7766 60.1351 56.0589 59.3566 54.7615C59.3468 54.745 59.3372 54.7283 59.328 54.7116L54.7928 46.4763L54.7559 46.4051C54.396 45.6651 54.6758 44.7649 55.4048 44.3635C56.1573 43.9491 57.1032 44.223 57.5176 44.9754L62.0511 53.2068C64.0868 56.6747 61.4627 60.8877 57.5875 60.8878H20.5884C16.6001 60.8876 14.2686 56.582 16.1222 53.2116L16.1253 53.2068L24.0024 39.0041Z"
      fill="#FF9800"
    />
    <path
      d="M37.5325 43.8161V31.8812C37.5325 31.0221 38.2289 30.3256 39.088 30.3256C39.9471 30.3256 40.6436 31.0221 40.6436 31.8812V43.8161C40.6436 44.6752 39.9471 45.3716 39.088 45.3716C38.2289 45.3716 37.5325 44.6752 37.5325 43.8161Z"
      fill="#FF9800"
    />
    <path
      d="M39.0887 53.961C40.407 53.961 41.4757 52.8923 41.4757 51.574C41.4757 50.2557 40.407 49.187 39.0887 49.187C37.7704 49.187 36.7017 50.2557 36.7017 51.574C36.7017 52.8923 37.7704 53.961 39.0887 53.961Z"
      fill="#FF9800"
    />
  </svg>,
  "WarningDialogIcon"
);

export default WarningDialogIcon;
